var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paperDetails" },
    [
      _c("div", { staticClass: "search_container" }, [
        _c(
          "div",
          { staticClass: "search_left" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "search_Box",
                attrs: { size: "mini", inline: true, model: _vm.PaperData },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "试卷名称" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入试卷名称" },
                      on: {
                        change: function ($event) {
                          return _vm.getPaperList(1)
                        },
                      },
                      model: {
                        value: _vm.PaperData.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.PaperData, "content", $$v)
                        },
                        expression: "PaperData.content",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "mySelect", attrs: { label: "科目分类" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        on: {
                          change: function ($event) {
                            return _vm.getPaperList(1)
                          },
                        },
                        model: {
                          value: _vm.PaperData.subjectId,
                          callback: function ($$v) {
                            _vm.$set(_vm.PaperData, "subjectId", $$v)
                          },
                          expression: "PaperData.subjectId",
                        },
                      },
                      _vm._l(_vm.subjectList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.getPaperList(1)
                  },
                },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "search_right" }, [
          _c("div", { staticClass: "backBtn", on: { click: _vm.backBtn } }, [
            _c("img", {
              staticClass: "backIcon",
              attrs: {
                src: require("../../../assets/image/home/back.png"),
                alt: "",
              },
            }),
            _vm._v("返回"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "comPractice_container" },
        [
          _c("div", { staticClass: "title_box" }, [
            _c("div", { staticClass: "left_title" }, [
              _c("span", { staticClass: "planName" }, [
                _vm._v(_vm._s(_vm.planInfoData.schemeName)),
              ]),
              _vm._v(" | "),
              _c("span", { staticClass: "subjectName" }, [
                _vm._v(_vm._s(_vm.planInfoData.professionName)),
              ]),
              _vm._v(" | "),
              _c("span", { staticClass: "grade" }, [
                _vm._v(" " + _vm._s(_vm.planInfoData.raceName)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "btn_box" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.AddTestPaperBtn },
                  },
                  [_vm._v("添加试卷")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.removeTestPaperBtn("batch")
                      },
                    },
                  },
                  [_vm._v("批量移除试卷")]
                ),
              ],
              1
            ),
          ]),
          _c("basic-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "paperDetailsBasicTable",
            attrs: {
              isCheckbox: true,
              tableHeader: _vm.examPaperDisplayList,
              tableData: _vm.tableData,
            },
            on: { operation: _vm.operation },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.removeTestPaperBtn("single", data.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("pagination", {
            attrs: { total: _vm.total, limit: _vm.limitSize, page: _vm.pageNo },
            on: {
              "update:limit": function ($event) {
                _vm.limitSize = $event
              },
              "update:page": function ($event) {
                _vm.pageNo = $event
              },
              currentChange: _vm.currentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "addPaperTestDialog",
          attrs: {
            title: "选择试卷",
            visible: _vm.addPaperTestVisible,
            width: "800px",
            "before-close": _vm.AddTesthandleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addPaperTestVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog_container" },
            [
              _c(
                "div",
                { staticClass: "searchBox" },
                [
                  _c(
                    "div",
                    { staticClass: "searchBox_left" },
                    [
                      _c("div", { staticClass: "margin_box" }, [
                        _vm._v("试卷名称"),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { size: "mini", placeholder: "请输入试卷名称" },
                        on: {
                          change: function ($event) {
                            return _vm.getpaperTestFun(1)
                          },
                        },
                        model: {
                          value: _vm.PaperTestForm.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.PaperTestForm, "content", $$v)
                          },
                          expression: "PaperTestForm.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "searchBox_right" },
                    [
                      _c("div", { staticClass: "margin_box" }, [
                        _vm._v("科目分类"),
                      ]),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            clearable: "",
                            placeholder: "请选择科目分类",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.getpaperTestFun(1)
                            },
                          },
                          model: {
                            value: _vm.PaperTestForm.subjectId,
                            callback: function ($$v) {
                              _vm.$set(_vm.PaperTestForm, "subjectId", $$v)
                            },
                            expression: "PaperTestForm.subjectId",
                          },
                        },
                        _vm._l(_vm.subjectList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.getpaperTestFun(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "basicTable" },
                [
                  _c("basic-table", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingCopy,
                        expression: "loadingCopy",
                      },
                    ],
                    ref: "paperTestTable",
                    attrs: {
                      isSelectPaper: true,
                      TableHeight: "100%",
                      isCheckbox: true,
                      isOperate: false,
                      tableHeader: _vm.examPaperDisplayList,
                      tableData: _vm.paperTestData,
                    },
                    on: { operation: _vm.paperTestOperation },
                  }),
                ],
                1
              ),
              _c("pagination", {
                attrs: {
                  total: _vm.totalCopy,
                  limit: _vm.pagesize,
                  page: _vm.current,
                },
                on: {
                  "update:limit": function ($event) {
                    _vm.pagesize = $event
                  },
                  "update:page": function ($event) {
                    _vm.current = $event
                  },
                  currentChange: _vm.currentChangePaperTest,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancelBtn } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.paperTestSureBtn },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }